import instance, { ADMIN_PREFIX } from 'services/api';
import {
  UserAttributesInput,
  UserGroupAttributesInput
} from 'types/api/attributes';

export interface DoctorUserAttributeRow {
  id: number;
  user_id: number;
  attribute_id: number;
  value: string;
  row_index: number;
  sort_index: number;
  [key: string]: unknown;
}

/**
 * POST /api/v2/admin/user-group — replaces user-group attribute rows
 * for (user_id, group_id, lang). Each entry in `values` is a row.
 */
export const createUserGroupAttributes = (input: UserGroupAttributesInput) =>
  instance.post(`${ADMIN_PREFIX}/user-group`, input);

/**
 * POST /api/v2/admin/user-group/user-attributes — replaces a user's
 * flat attribute map. `lang` accepted (cycle-9 closure) but not yet
 * persisted server-side.
 */
export const createUserAttributes = (input: UserAttributesInput) =>
  instance.post(`${ADMIN_PREFIX}/user-group/user-attributes`, input);

/**
 * GET /api/v2/admin/user-group/doctor/:id — flat user_attributes rows
 * for the doctor across all groups. Used by DoctorProfile/DynamicPage
 * as the GAP-4 fallback until a follow-up cycle hydrates groups
 * inline on the doctor detail.
 */
export const fetchDoctorUserAttributes = async (
  doctorId: number | string,
  lang: string,
  groupId?: number | string
): Promise<DoctorUserAttributeRow[]> => {
  const res = await instance.get(
    `${ADMIN_PREFIX}/user-group/doctor/${doctorId}`,
    { params: { lang, group_id: groupId } }
  );

  return Array.isArray(res?.data?.data) ? res.data.data : res?.data ?? [];
};
